@if (isAgentUser()) {
  @if (currentUser(); as user) {
    <ui-agent-bar (openSettings)="agentSideSheet.open()" [currentUser]="user"></ui-agent-bar>
  }

  <ng-template [width]="agentSideSheetWidth()" uiSideSheetSide="right" #agentSideSheet="SideSheetDirective">
    <ui-side-sheet-header (closeSideSheet)="agentSideSheet.close()">Agentenfunktion</ui-side-sheet-header>
    <div class="wrapper-side-sheet-content">
      <ui-agent-search (userSelected)="agentSideSheet.close()"></ui-agent-search>
      <hr>
      <div class="actions">
        <ui-button (clicked)="logout(); agentSideSheet.close()">
          Agent abmelden
        </ui-button>
        <ui-button (clicked)="agentSideSheet.close()" buttonStyle="outlined">
          Schließen
        </ui-button>
      </div>
    </div>
  </ng-template>
}
